import React, { useEffect } from "react";
import { CircularProgress } from "@material-ui/core";

export const Spinner = ({ animate }) => {
  // animate
  //   ? (document.body.style.overflow = "hidden")
  //   : (document.body.style.overflow = "unset");
  return animate ? (
    <div className="position-fixed vh-100 top-0 start-0 d-flex align-items-center justify-content-center w-100 blur-filter-background">
      <div className="loading-background rounded-circle bg-white shadow position-absolute p-2 d-flex justify-content-center align-items-center">
        <CircularProgress
          className="rounded-circle"
          color="success"
          sx={{ fontSize: 10, color: "#002244" }}
          disableShrink
        />
      </div>
    </div>
  ) : null;
};
